import { graphql } from '@/lib/graphql';

export const QueueDashboardQueuesSubscription = graphql(`
  subscription QueueDashboardQueues($organizationId: Uuid!, $since: Timestamptz!) {
    queues(where: { organizationId: { _eq: $organizationId } }, orderBy: { name: ASC }) {
      id
      name
      enabled
      routingStrategy
      slaTargetSecs
      ringing: queueEntriesAggregate(where: { status: { _eq: "ringing" } }) {
        aggregate {
          count
        }
      }
      answered: queueEntriesAggregate(where: { status: { _eq: "answered" } }) {
        aggregate {
          count
        }
      }
      queueMembers {
        id
        memberId
      }
      waitingEntries: queueEntries(where: { status: { _eq: "waiting" } }) {
        id
        enteredAt
      }
      recentEntries: queueEntries(where: { enteredAt: { _gte: $since } }) {
        id
        status
        enteredAt
        answeredAt
      }
    }
  }
`);

export const QueueDashboardAgentStatusSubscription = graphql(`
  subscription QueueDashboardAgentStatus($organizationId: Uuid!) {
    agentStatus(where: { organizationId: { _eq: $organizationId } }) {
      id
      memberId
      statusName
      statusChangedAt
      softphoneConnected
      lastHeartbeat
      currentCallControlId
      currentQueueEntryId
      currentAgentCallSessionId
    }
  }
`);

export const QueueDashboardStatusDefinitionsSubscription = graphql(`
  subscription QueueDashboardStatusDefinitions($organizationId: Uuid!) {
    agentStatusDefinitions(where: { organizationId: { _eq: $organizationId } }, orderBy: { displayOrder: ASC }) {
      id
      name
      label
      color
      availableForRouting
      isSystem
      displayOrder
    }
  }
`);

export const QueueDashboardQueueSubscription = graphql(`
  subscription QueueDashboardQueue($queueId: Uuid!, $since: Timestamptz!) {
    queuesByPk(id: $queueId) {
      id
      name
      routingStrategy
      maxWaitTimeSecs
      ringTimeoutSecs
      slaTargetSecs
      enabled
      answered: queueEntriesAggregate(where: { status: { _eq: "answered" } }) {
        aggregate {
          count
        }
      }
      liveEntries: queueEntries(
        where: { status: { _in: ["waiting", "ringing"] } }
        orderBy: [{ priority: ASC }, { enteredAt: ASC }]
      ) {
        id
        callControlId
        callerNumber
        priority
        status
        enteredAt
      }
      recentEntries: queueEntries(where: { enteredAt: { _gte: $since } }) {
        id
        status
        enteredAt
        answeredAt
      }
      queueMembers(orderBy: { priority: ASC }) {
        id
        priority
        member {
          id
          email
          extensionNumber
          agentStatuses {
            id
            statusName
            statusChangedAt
            softphoneConnected
            lastHeartbeat
            currentCallControlId
          }
        }
      }
    }
  }
`);
